import React from 'react';
import { year } from 'Helpers/NumberInputFormats';
import NumberInput from '../NumberInput';

import './index.css';

const Year = props => <NumberInput {...year} {...props} />;

export default Year;
